<script setup lang="ts">
import SmsChatDetailsDescListItem from '@/components/items/SmsChatDetailsDescListItem.vue';

export interface Props {
  phone?: string;
  email?: string;
  state?: string;
  driverCode?: number;
}

const props = withDefaults(defineProps<Props>(), {
  phone: undefined,
  email: undefined,
  state: undefined,
  driverCode: undefined,
});
</script>

<template>
  <dl
    :class="$style.smsChatDetailsDescList"
    data-testid="smsChatDetailsDescList"
  >
    <SmsChatDetailsDescListItem
      :class="$style.item"
      term="Primary phone"
      :details="props.phone"
    />
    <SmsChatDetailsDescListItem
      :class="$style.item"
      term="Email"
      :details="props.email"
    />
    <div :class="$style.stateAndDriver">
      <SmsChatDetailsDescListItem
        :class="$style.item"
        term="State"
        :details="props.state"
      />
      <SmsChatDetailsDescListItem
        :class="$style.item"
        term="Driver"
        :details="props.driverCode"
      />
    </div>
  </dl>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.smsChatDetailsDescList {
  margin: 0;

  & > .item:first-child {
    margin-top: 0;
  }
}
  .item {
    margin-top: 10px;
    min-width: 55px;
  }
  .stateAndDriver {
    display: flex;

    .item + .item {
      margin-left: 10px;
    }
  }
</style>
